import {
  FieldDefinitionNode,
  parse,
  visit,
  print,
  ObjectTypeDefinitionNode,
  DocumentNode,
} from 'graphql';
import { Project, Schema } from 'hooks/projects';
import { v1 as uuidv1 } from 'uuid';
import { PRIMARY_KEY_FDM } from './config';

const getTypesFromSchema = (schema: DocumentNode) =>
  schema.definitions.filter(
    (el) => el.kind === 'ObjectTypeDefinition'
  ) as ObjectTypeDefinitionNode[];

export function generateSchemas(
  graphqlString: string,
  tenant: string
): Schema[] {
  if (!graphqlString) return [];
  const rootAst = parse(graphqlString);
  const objectTypeDefinitions = getTypesFromSchema(rootAst);
  const schemas = objectTypeDefinitions.map(
    (objectTypeDefinition, orderIndex) => {
      const schema: Schema = {
        id: uuidv1(),
        tenant,
        orderIndex,
        project: {} as Project,
        instanceCount: 0,
        name: objectTypeDefinition.name.value,
        properties: [],
      };
      schema.properties.push({
        id: uuidv1(),
        tenant,
        orderIndex: schema.properties.length,
        name: PRIMARY_KEY_FDM,
        directives: [],
        type: 'ID',
      });
      visit(objectTypeDefinition, {
        FieldDefinition: {
          enter(field: FieldDefinitionNode) {
            schema.properties?.push({
              id: uuidv1(),
              tenant,
              orderIndex: schema.properties.length,
              name: field.name.value,
              directives: field.directives?.map((el) => el.name.value) || [],
              type: print(field.type),
            });
          },
        },
      });
      return schema;
    }
  );
  assignPropertySchemas(schemas);
  return schemas;
}

function getPropertyType(value: string) {
  value = value.replace('!', '').replace(/^\[/, '').replace(/\]$/, '');
  return {
    isBasic: [
      'String',
      'Int',
      'Float',
      'Int64',
      'JSONObject',
      'Timeseries',
      'Timestamp',
      'Boolean',
    ].includes(value),
    typename: value,
  };
}

/**
 * We need to assign the schemas to properties which are related to other schemas.
 * This helps when we want to find the field type of nested comparison
 * Example Movies -> Director -> Age should have a field type of Int.
 */
function assignPropertySchemas(schemas: Schema[]) {
  schemas.forEach((schema) => {
    schema.properties.forEach((property) => {
      const { isBasic, typename } = getPropertyType(property.type);
      if (!isBasic) {
        property.schema = schemas.find((sc) => sc.name === typename);
      }
    });
  });
}
